<template>
    <div class="stages-base">
      <Stage :stages="stages.stage" :startHours="stages.startTime" :endHours="stages.endTime" :openText="openText" :bodyColor="bodyColor" ref="setHeight"></Stage>
      <div class="stages-base-line">
        <div class="hr" v-for="time in times" v-bind:key="time.time">
          <hr/>
        </div>
      </div>
    </div>
</template>

<script>
import Stage from './Stage'
export default {
  name: 'StageBase',
  props: {
    startTime: '',
    endTime: '',
    stages: {
      type: Array,
      required: true
    },
    openText: '',
    bodyColor: ''
  },
  data () {
    return {
      times: []
    }
  },
  watch: {
    startTime: function (val) {
      this.startTime = val
      this.setHrTime()
    },
    endTime: function (val) {
      this.endTime = val
      this.setHrTime()
    }
  },
  components: {
    Stage
  },
  mounted () {
    this.setHrTime()
  },
  methods: {
    setHrTime: function () {
      this.times = []
      for (let i = this.startTime; i <= this.endTime; i++) {
        this.times.push(i + ':00')
      }
      this.$refs.setHeight()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/components/parts/StageBase";
</style>



// WEBPACK FOOTER //
// src/components/parts/StageBase.vue